export default __webpack_public_path__ + "assets/642ef4a8a80b7e47536e825b23d0d759.jpg";